import { useRegisterSW } from 'virtual:pwa-register/react';
import { Button } from '@/components/ui/Button';
import { useI18n } from '@/i18n/context';

/**
 * Offers new versions instead of reloading by itself, so a child is never
 * interrupted in the middle of a game.
 */
export function PwaPrompt() {
  const { t } = useI18n();
  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  if (!offlineReady && !needRefresh) return null;
  const playing = window.location.pathname.startsWith('/learn/play');
  if (needRefresh && playing) return null;

  return (
    <div
      role="status"
      className="no-print fixed inset-x-4 bottom-24 z-50 mx-auto flex max-w-md items-center gap-3 rounded-2xl bg-ink p-4 text-white shadow-[var(--shadow-raised)] md:bottom-6"
    >
      <p className="flex-1 text-sm">
        {needRefresh ? t('app.updateAvailable') : t('app.offlineReady')}
      </p>
      {needRefresh && (
        <Button size="md" variant="sun" onClick={() => void updateServiceWorker(true)}>
          {t('app.updateNow')}
        </Button>
      )}
      <Button
        size="md"
        variant="ghost"
        className="text-white hover:bg-white/10"
        onClick={() => {
          setOfflineReady(false);
          setNeedRefresh(false);
        }}
      >
        {needRefresh ? t('app.later') : t('app.close')}
      </Button>
    </div>
  );
}
